import { render, staticRenderFns } from "./BotQuickReplyMessage.vue?vue&type=template&id=3294f878&scoped=true"
import script from "./BotQuickReplyMessage.vue?vue&type=script&lang=js"
export * from "./BotQuickReplyMessage.vue?vue&type=script&lang=js"
import style0 from "./BotQuickReplyMessage.vue?vue&type=style&index=0&id=3294f878&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3294f878",
  null
  
)

export default component.exports